module.exports = __webpack_public_path__ + "assets/sectigo.e59af813.svg";